var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([_vm.customCss])},[_c('img',{staticClass:"w-full h-full object-cover",attrs:{"src":_vm.themeSettings.configuration_options.background_image}}),_c('div',{staticClass:"w-full h-full absolute left-0 top-0 body-overlay-color"})])
}
var staticRenderFns = []

export { render, staticRenderFns }